import { countryData } from '../../customTable/tables/send-exchange-table';

export const currencyCalculatorData = [];

countryData.forEach((country) => {
  if (country.includeInCalculator) {
    currencyCalculatorData.push({
      currency: country.code,
      name: country.displayName,
      swift: country.swiftFee,
      local: country.localNetworkFee,
      symbol: country.symbol
    });
  }
});
